module.exports = __webpack_public_path__ + "img/block-center-large.06ffa065.png";